<template>
<div class='financial-report-wrap'>
    <van-nav-bar v-if="title"     :title="title"      left-arrow      @click-left="$router.go(-1)"   :right-text="currDate"     @click-right="showDate = true" />
     <router-view ref="routeComponent" v-if="isRouterAlive"></router-view>
    <change-ym :show="showDate" @change="onYmChange" />
</div>
</template>

<script>
import ChangeYm from '@/components/commons/change-ym'
import { mapGetters } from "vuex";

export default {
  components: { ChangeYm },
  data(){
    return {
      showDate:false,
      isRouterAlive:true,
      title:''
    }
  },
    computed: {
    ...mapGetters(['currClient',"currDate"])
  },
  watch:{
    $route: {
    handler: function(val, oldVal){
     let  {name} = val
     let  metaTitle = val.meta.title

      switch(name){
        case 'financial-report-index':
          this.title = ''
          break;
        case 'basic-info':
          this.title = this.currClient.name
          break;
          default:
            this.title = metaTitle
      }
    },
    deep: true,
    immediate:true

  }
  },
    methods: {
    onYmChange(show, ym) {
      if(ym){
        this.showDate = show
        let date = ym+'-01'
        this.$store.dispatch("app/setCurrentDate", date);
        window.localStorage.removeItem('balanceData')
        this.isRouterAlive = false
        this.$nextTick(() => (this.isRouterAlive = true))
      }

    },
  }
}
</script>

<style lang='less'>
.financial-report-wrap{
  .van-nav-bar__title{
    max-width:50%
}

}

</style>


// WEBPACK FOOTER //
// src/components/views/financial-report/layout.vue